export default {
  getListOffersSeparate: state => state.listOffersSeparate,
  getOptionsOffersSeparate: state => state.optionsOffersSeparate,
  getPaginationOffersSeparate: state => state.paginationOffersSeparate,
  getCurrentPage: state => state.currentPage,
  getSeparateFilter: state => state.separateFilter
}
